import React, { useState } from "react";
import api from "../../../services/api";
import { fmtDateFull, fmtNum, todayISO } from "../../../shared/utils";
import { sourceImage } from "../../../utils/source-image";

const CORES_CATEGORIA = {
  salgado: "#FF8C42",
  doce: "#EC4899",
  bebida: "#3B82F6",
  geral: "#9B59B6",
};
const LABEL_CATEGORIA = { salgado: "Salgado", doce: "Doce", bebida: "Bebida" };

export default function Cardapio({
  cardapio,
  currentStudent,
  getTokensDisponiveis,
  redemptions,
  setRedemptions,
  showFlash,
  goto,
}) {
  const [filtro, setFiltro] = useState("todos");
  const cats = [
    { id: "todos", label: "Todos" },
    { id: "salgado", label: "Salgados" },
    { id: "doce", label: "Doces" },
    { id: "bebida", label: "Bebidas" },
  ];

  const tok = currentStudent
    ? Math.max(0, getTokensDisponiveis(currentStudent.id))
    : 0;

  const itens = (cardapio || []).filter(
    (i) => i.ativo && (filtro === "todos" || i.categoria === filtro),
  );

  const meusResgates = (redemptions || [])
    .filter((r) => r.aluno_id === currentStudent?.id)
    .sort((a, b) => b.id - a.id);
  const statusLabel = {
    pendente: "Aguardando",
    aprovado: "Aprovado",
    cancelado: "Cancelado",
  };
  const statusCor = {
    pendente: { bg: "#FFF3CD", color: "#856404" },
    aprovado: { bg: "#E0F5F0", color: "#1A7A6E" },
    cancelado: { bg: "#FFE5E0", color: "#B83A2E" },
  };

  const resgatar = async (item) => {
    if (!currentStudent) {
      showFlash("Faca login primeiro.", "er");
      goto("login-aluno");
      return;
    }
    if (tok < item.custo_token) {
      showFlash(
        `Tokens insuficientes! Você tem ${fmtNum(tok)}, precisa de ${fmtNum(item.custo_token)}.`,
        "er",
      );
      return;
    }
    if (item.estoque !== null && item.estoque <= 0) {
      showFlash("Item sem estoque.", "er");
      return;
    }

    try {
      const { data } = await api.post("/redemptions", {
        aluno_id: currentStudent.id,
        item_id: item.id,
        item_nome: item.nome,
        pontos: item.custo_token,
        data: todayISO(),
      });
      setRedemptions([...redemptions, data.data]);
      showFlash(`Resgate realizado! -${fmtNum(item.custo_token)} tokens.`);
    } catch (err) {
      showFlash(
        err.response?.data?.message || "Nao foi possivel solicitar o resgate.",
        "er",
      );
    }
  };

  return (
    <div className="cn">
      <h1 className="pt">
        <em>Cardápio</em>
      </h1>
      <div className="ps">
        Confira os itens disponíveis, os preços e resgate recompensas com seus
        tokens
      </div>

      {currentStudent && (
        <div
          style={{
            background: "rgba(255,255,255,0.12)",
            borderRadius: 12,
            padding: "16px",
            marginBottom: 14,
          }}
        >
          <div
            style={{
              fontSize: 9,
              color: "rgba(255,255,255,0.5)",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: ".15em",
              marginBottom: 4,
            }}
          >
            Saldo de Tokens
          </div>
          <div
            style={{
              fontSize: 34,
              fontWeight: 900,
              color: "#4FB3A9",
              lineHeight: 1,
            }}
          >
            {fmtNum(tok)}{" "}
            <small
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "rgba(255,255,255,0.55)",
              }}
            >
              tokens
            </small>
          </div>
          <div
            style={{
              fontSize: 11,
              color: "rgba(255,255,255,0.4)",
              marginTop: 7,
            }}
          >
            Pague em dinheiro no local ou resgate itens usando seus tokens.
          </div>
        </div>
      )}

      <div className="tabs" style={{ marginBottom: 16 }}>
        {cats.map((c) => (
          <button
            key={c.id}
            className={filtro === c.id ? "a" : ""}
            onClick={() => setFiltro(c.id)}
          >
            {c.label}
          </button>
        ))}
      </div>
      {itens.length === 0 ? (
        <div className="es">
          <h3>Nenhum item nesta categoria</h3>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill,minmax(155px,1fr))",
            gap: 12,
          }}
        >
          {itens.map((item) => {
            const cor = CORES_CATEGORIA[item.categoria] || CORES_CATEGORIA.geral;
            const temToken = item.custo_token !== null && item.custo_token > 0;
            const temDinheiro = item.preco !== null && item.preco > 0;
            const podeResgatar =
              temToken &&
              currentStudent &&
              tok >= item.custo_token &&
              (item.estoque === null || item.estoque > 0);
            return (
              <div
                key={item.id}
                style={{
                  background: "#FFF",
                  borderRadius: 14,
                  overflow: "hidden",
                  boxShadow: "0 2px 12px rgba(0,0,0,.09)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {item.foto ? (
                  <img
                    src={sourceImage(item.foto)}
                    alt={item.nome}
                    style={{
                      width: "100%",
                      height: 110,
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "100%",
                      height: 110,
                      background: cor + "22",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 36,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: cor,
                        textAlign: "center",
                        padding: 8,
                      }}
                    >
                      {item.nome}
                    </div>
                  </div>
                )}
                <div
                  style={{
                    padding: "10px 12px",
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    gap: 4,
                  }}
                >
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 800,
                      color: "#1F4754",
                      lineHeight: 1.2,
                    }}
                  >
                    {item.nome}
                  </div>
                  {item.descricao && (
                    <div
                      style={{
                        fontSize: 11,
                        color: "#6B8590",
                        lineHeight: 1.35,
                        flex: 1,
                      }}
                    >
                      {item.descricao}
                    </div>
                  )}
                  {item.categoria && (
                    <div>
                      <span
                        style={{
                          fontSize: 9,
                          fontWeight: 700,
                          padding: "3px 8px",
                          borderRadius: 999,
                          background: cor + "20",
                          color: cor,
                          textTransform: "uppercase",
                          letterSpacing: ".06em",
                        }}
                      >
                        {LABEL_CATEGORIA[item.categoria] || item.categoria}
                      </span>
                    </div>
                  )}
                  {temDinheiro && (
                    <div
                      style={{ fontSize: 16, fontWeight: 900, color: "#4FB3A9" }}
                    >
                      R$ {Number(item.preco).toFixed(2).replace(".", ",")}
                    </div>
                  )}
                  {temToken && (
                    <div style={{ marginTop: temDinheiro ? 6 : 0 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: 6,
                        }}
                      >
                        <span
                          style={{
                            fontSize: 13,
                            fontWeight: 800,
                            color: "#9B59B6",
                          }}
                        >
                          {fmtNum(item.custo_token)} tokens
                        </span>
                        {item.estoque !== null && (
                          <span style={{ fontSize: 10, color: "#6B8590" }}>
                            {item.estoque > 0
                              ? `${item.estoque} est.`
                              : "Esgotado"}
                          </span>
                        )}
                      </div>
                      <button
                        className="btn bb"
                        style={{
                          width: "100%",
                          fontSize: 12,
                          padding: "9px 0",
                          background: podeResgatar ? "#4FB3A9" : "#B8C5CC",
                        }}
                        onClick={() => resgatar(item)}
                        disabled={!podeResgatar}
                      >
                        {!currentStudent
                          ? "Entrar"
                          : item.estoque !== null && item.estoque <= 0
                            ? "Esgotado"
                            : tok < item.custo_token
                              ? `Faltam ${fmtNum(item.custo_token - tok)} tok`
                              : "Resgatar"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {currentStudent && (
        <>
          <div className="dv dv-dark" style={{ marginTop: 22 }}>
            <span>Minhas Compras ({meusResgates.length})</span>
          </div>
          {meusResgates.length === 0 ? (
            <div
              style={{
                background: "rgba(255,255,255,0.06)",
                borderRadius: 12,
                padding: "20px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: 13, color: "rgba(255,255,255,0.5)" }}>
                Nenhuma compra ainda.
              </div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 7 }}>
              {meusResgates.map((r, idx) => {
                const sc = statusCor[r.status] || statusCor.pendente;
                return (
                  <div
                    key={r.id}
                    style={{
                      background: "#FFF",
                      borderRadius: 12,
                      display: "flex",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                    }}
                  >
                    <div
                      style={{
                        width: 4,
                        flexShrink: 0,
                        background:
                          r.status === "aprovado"
                            ? "#4FB3A9"
                            : r.status === "cancelado"
                              ? "#D9534F"
                              : "#F59E0B",
                      }}
                    />
                    <div
                      style={{
                        flex: 1,
                        padding: "11px 13px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 5,
                            marginBottom: 3,
                          }}
                        >
                          <span
                            style={{
                              fontSize: 10,
                              fontWeight: 800,
                              color: "#B8C5CC",
                            }}
                          >
                            #{meusResgates.length - idx}
                          </span>
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: 700,
                              color: "#1F4754",
                            }}
                          >
                            {r.item_nome}
                          </span>
                        </div>
                        <div style={{ fontSize: 11, color: "#6B8590" }}>
                          Comprado em {fmtDateFull(r.data)}
                        </div>
                        <div style={{ marginTop: 4 }}>
                          <span
                            style={{
                              fontSize: 10,
                              fontWeight: 700,
                              padding: "2px 8px",
                              borderRadius: 999,
                              ...sc,
                            }}
                          >
                            {statusLabel[r.status] || r.status}
                          </span>
                        </div>
                      </div>
                      <div style={{ textAlign: "right", flexShrink: 0 }}>
                        <div
                          style={{
                            fontSize: 16,
                            fontWeight: 800,
                            color: "#D9534F",
                            lineHeight: 1,
                          }}
                        >
                          -{fmtNum(r.pontos)}
                        </div>
                        <div
                          style={{
                            fontSize: 9,
                            color: "#6B8590",
                            fontWeight: 600,
                            textTransform: "uppercase",
                            marginTop: 2,
                          }}
                        >
                          Tokens
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              <div
                style={{
                  background: "rgba(255,255,255,0.07)",
                  borderRadius: 10,
                  padding: "9px 13px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: 12,
                    color: "rgba(255,255,255,0.6)",
                    fontWeight: 600,
                  }}
                >
                  Total gasto
                </span>
                <span
                  style={{ fontSize: 15, fontWeight: 800, color: "#D9534F" }}
                >
                  -
                  {fmtNum(
                    meusResgates
                      .filter((r) => r.status !== "cancelado")
                      .reduce((s, r) => s + r.pontos, 0),
                  )}{" "}
                  tokens
                </span>
              </div>
            </div>
          )}
        </>
      )}
      {!currentStudent && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <button className="btn" onClick={() => goto("login-aluno")}>
            Entrar para resgatar
          </button>
        </div>
      )}
    </div>
  );
}
